// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page[data-v-19a6a110]{background:#00446b!important;height:100%;min-height:100vh}#btnHome[data-v-19a6a110]{border-radius:26px;color:#000;font-size:24px}#btnHome[data-v-19a6a110]:hover{background:red;border-color:red;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
